module.exports = __webpack_public_path__ + "assets/7ab796b1368696602488521b18cc3a0c.png";